import request from '@/utils/request'
import constant from '@/api/constant'
import { getToken } from '@/utils/cookies'
import secret from '@/utils/secret'

export function findToken () { // 获取token
  return request({
    url: '/zauser/findtoken',
    method: 'post',
    params: {
      appCode: 'sso',
      platform: constant.TOKENPARAMS
    }
  })
}

export function loginByUsername (username, password) { // 根据登录名登录 密码加密
  return request({
    url: '/zauser/newLoginZaUserEncryption',
    method: 'post',
    params: {
      token: getToken()
    },
    data:{
      loginName: username,
      password: secret.loginPwdEncrypt(password),
      appCode: 'sso'
    }
  })
}

export function loginByUsernamess (username, password) { // 根据登录名登录 废弃
  return request({
    url: '/zauser/newLoginZaUser',
    method: 'post',
    params: {
      token: getToken()
    },
    data:{
      loginName: username,
      password: password,
      appCode: 'sso'
    }
  })
}

export function loginByMobile (mobile, code) { // 根据手机号登录
  return request({
    url: '/zauser/loginByMobile',
    method: 'post',
    params: {
      mobile: mobile,
      smscode: code,
      appCode: 'sso'
    }
  })
}

export function getUserInfo () { // 根据token获取用户信息
  return request({
    url: '/zauser/findZaUserByToken',
    method: 'post'
  })
}

export function logout () { // 登出
  return request({
    url: '/zauser/loginZaUserOut',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js